var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { setBookAvailability } from "@/05-models/book";
import { cancelOrder, confirmOrder, removeOrder } from "@/05-models/order";
import { useErrorNotify } from "@/06-shared/lib/errorNotifier";
import styles from "./index.module.css";
export const ShowOrderItem = ({ order }) => {
    const showError = useErrorNotify();
    const cancel = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield cancelOrder(order.id);
            removeOrder(order.id);
        }
        catch (error) {
            showError(error);
        }
    });
    const confirm = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield confirmOrder(order.id);
            removeOrder(order.id);
            setBookAvailability(order.bookId, false);
        }
        catch (error) {
            showError(error);
        }
    });
    return (_jsxs("article", { className: styles.order, children: [_jsxs("div", { children: [_jsxs("p", { className: styles.orderTitle, children: ["\u0417\u0430\u044F\u0432\u043A\u0430 #", order.id] }), _jsxs("p", { children: ["\u041A\u043D\u0438\u0433\u0430 #", order.bookId] }), _jsxs("p", { children: ["\u0418\u0441\u0442\u0435\u043A\u0430\u0435\u0442: ", new Date(order.expiresAt).toLocaleString("ru-RU", {
                                dateStyle: "short",
                                timeStyle: "short",
                            })] })] }), _jsxs("div", { className: styles.actions, children: [_jsx("button", { onClick: confirm, children: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C" }), _jsx("button", { onClick: cancel, children: "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C" })] })] }));
};
